import template from './events_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AdminEventsComponentViewModel
{
	constructor(bindings)
	{
		let today = new Date();
		let oneyear = new Date().setFullYear(new Date().getFullYear() + 1);
		this.events = ko.observableArray([]);
		this.colors = ko.observableArray();
		this.hex_colour = ko.observable();
		this.from_date = ko.observable(new Date(today).toJSON().slice(0, 10));
		this.to_date = ko.observable(new Date(oneyear).toJSON().slice(0, 10));
		this.bindings = bindings;

		this.from_date.subscribe((value) => {
			this.updateData();
		});

		this.to_date.subscribe((value) => {
			this.updateData();
		});

		// PAGE LOAD`
		this.init();
	}

	async updateData()
	{
		if (this.from_date() && this.to_date() && this.to_date() < this.from_date())
		{
			Grape.alerts.alert({type: 'warning', title: 'Invalid dates', message: 'The To date can not be smaller than the from date'});
			return;
		}

		let options = {
				table: 'events',
				schema: 'public',
				sortfield: 'event_date',
				sortorder: 'asc',
				limit: 1000000,
				filter: [{value: this.from_date(), op: '>=', field: 'event_date'},
					{value: this.to_date(), op: '<=', field: 'event_date'}]
		};

		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res.records)
		{
			for (let i = 0; i < res.records.length; i++)
			{
				let colour_info = this.colors().find(item => item.hexcolor === res.records[i].hex_colour);
				if (colour_info != null)
					res.records[i].colour = colour_info.name
				else
					res.records[i].colour  = res.records[i].hex_colour
			}
			this.events(res.records);
		}
		Utils.refresh_data_visible_roles();
	};

	async init()
	{
		if (await Utils.redirectOnAccessDenied('EventsAdministration'))
			return;

		let res = await Grape.fetches.getJSON('/api/record', { table: 'colors', limit: 100 });
		this.colors(res.records);
		
		$('#colour_picker').select2({
			templateResult: this.formatSelect,
			templateSelection: this.formatSelect
		});

		this.updateData();
	};

	formatSelect = (entry) => {
		if (!entry.id) { return entry.text; }
		else
		{
			return $(
				`<div style="padding-top: 3px; line-height: 20px"><span class="select_color" style="background-color: ${entry.id}"></span>${entry.text}</div>`
			);
		}
	}

	edit_event(v, e)
	{
		var view_row = $(e.currentTarget).parent().parent().parent();
		var edit_row = $(e.currentTarget).parent().parent().parent().next();

		view_row.hide();
		edit_row.show();
	};

	async delete_event(v, e)
	{
		//var view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		//var edit_row = $(e.currentTarget).parent().parent().parent();

		var data = ko.mapping.toJS(v);
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this event entry ?')});
		
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/events/delete', data)
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted event.'), title: tr('Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
		this.updateData();
	};

	async save_event(v, e)
	{
		var view_row = $(e.currentTarget).parent().parent().prev();
		var edit_row = $(e.currentTarget).parent().parent();
		var data = ko.mapping.toJS(v);

		if (data.event_id == '')
			data.event_id = null;

		let res = await Grape.fetches.postJSON('/admin/events/edit', data)
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully saved event.'), title: tr('Success') });
			this.updateData();
			edit_row.hide();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		} else if (res.error)
		{
			Grape.alerts.alert({ type: 'error', 'message': res.error, 'title': tr('Error') });
			this.updateData();
		} else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

		view_row.show();
		edit_row.hide();
	};

	add_event(v, e)
	{
		let events = v.events;
		events.unshift({
			event_name: '',
			event_date: new Date().toISOString().split('T')[0],
			hex_colour: '#CCCCCC',
			colour: 'Light grey',
			event_id: ''
		});

		let row = $('#event_body > tr:first-child');
		row.hide();
		row.next().show();
	}

	cancel_edit(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().prev();
		var edit_row = $(e.currentTarget).parent().parent();
		view_row.next().hide();
		edit_row.hide();
		
		if (v.event_id)
			view_row.show();

		//this.updateData();
	}
};

export default {
	name: 'events_component',
	viewModel: AdminEventsComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/events_component'
};
